<app-stages [stages]='stages' currentStage='Prognozowane opłaty'></app-stages>
<br>
@if (!pending() && !loading()) {
  <div *ngIf='payment() as payment'>
    <app-accordion-group>
      <app-accordion-item
        *ngFor='let occupation of payment.roadOccupations'
        [name]='occupation.name + " [" + (calcTotalStageCost(occupation) | currency) + "]"'
        [expanded]='false'>
        <ng-container *ngFor='let stage of occupation.stages'>
          <div class='col-12 d-flex justify-content-between'>
            <strong>
              {{ stage.name }}
            </strong>
            <app-label [label]='"Okres:"'>
              {{ stage.start }}&nbsp;-&nbsp;{{ stage.end }}
            </app-label>
            <app-label label='Liczba dni:'>
              {{ stage.daysCount }}
            </app-label>
          </div>
          <br>
          <table class='table table-silver'>
            @if (application()?.service?.url === '/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi') {
              <caption class="mb-2">
                <strong class="d-flex justify-content-start ms-2">
                  Zajęcie pasa w roku bieżącym
                </strong>
              </caption>
            }
            <thead>
            <tr>
              <th>
                Nazwa powierzchni
              </th>
              <th>
                Powierzchnia
              </th>
              <th>
                Stawka
              </th>
              <th>
                Kwota
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor='let row of getCostPositions(stage)'>
              <td>
                {{ row?.surfaceName || '-' }}
              </td>
              <td>
                {{ row?.area | toNumber | number }}
              </td>
              <td>
                {{ row?.unitCost | toNumber | currency }}
              </td>
              <td>
                {{ row?.totalCost | toNumber | currency }}
              </td>
            </tr>
            </tbody>
            <tfoot *ngIf='!getCostPositions(stage).length'>
            <tr>
              <td colspan='4' class='no-data'>
                brak danych
              </td>
            </tr>
            </tfoot>
          </table>
          @if ((application()?.service?.url === '/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi') && (stage.years.length > 1)) {
            <br>
            <p>
              <strong class="d-flex justify-content-center">Zajęcie pasa na kolejne lata</strong>
            </p>
            @for (item of stage.years; track $index) {
              @if ($index !== 0) {
                <table class='table table-silver mt-2'>
                  <caption class="mb-2">
                    <strong class="d-flex justify-content-start ms-2">
                      {{ item.name }}
                    </strong>
                  </caption>
                  <thead>
                  <tr>
                    <th>
                      Nazwa powierzchni
                    </th>
                    <th>
                      Powierzchnia
                    </th>
                    <th>
                      Stawka
                    </th>
                    <th>
                      Kwota
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor='let row of item.costPositions'>
                    <td>
                      {{ row?.surfaceName || '-' }}
                    </td>
                    <td>
                      {{ row?.area | toNumber | number }}
                    </td>
                    <td>
                      {{ row?.unitCost | toNumber | currency }}
                    </td>
                    <td>
                      {{ row?.totalCost | toNumber | currency }}
                    </td>
                  </tr>
                  </tbody>
                  <tfoot *ngIf='!getCostPositions(stage).length'>
                  <tr>
                    <td colspan='4' class='no-data'>
                      brak danych
                    </td>
                  </tr>
                  </tfoot>
                </table>
              }
            }
          }
        </ng-container>
      </app-accordion-item>
    </app-accordion-group>
  </div>
  <br>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      [routerLink]='cancelUrl'>
    <span>
      Wstecz
    </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      [routerLink]='successUrl'>
      <span>
        Zapoznaj się i przejdź dalej
      </span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
